"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductCard = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _ic_guarantee = _interopRequireDefault(require("../../assets/images/ic_guarantee.png"));
var _shop_icon = _interopRequireDefault(require("../../assets/images/shop_icon.png"));
var _getPrefixCls = require("../../utils/getPrefixCls");
var _Button = require("../Button");
var _LocaleProvider = require("../LocaleProvider");
var _useTracking = require("../../hooks/useTracking");
var _constants = require("../../utils/constants");
var _clsx = _interopRequireDefault(require("clsx"));
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var ProductCard = function ProductCard(props) {
  var shopName = props.shopName,
    title = props.title,
    specification = props.specification,
    amount = props.amount,
    itemCount = props.itemCount,
    orderPrice = props.orderPrice,
    totalPrice = props.totalPrice,
    orderSn = props.orderSn,
    handleOrderDetailRedirect = props.handleOrderDetailRedirect,
    orderStatusText = props.orderStatusText,
    _props$shopImg = props.shopImg,
    shopImg = _props$shopImg === void 0 ? _shop_icon.default : _props$shopImg,
    image = props.image,
    _props$showOrderId = props.showOrderId,
    showOrderId = _props$showOrderId === void 0 ? false : _props$showOrderId,
    orderIdText = props.orderIdText,
    onButtonClick = props.onButtonClick,
    selectOrderText = props.selectOrderText,
    action = props.action,
    totalPaymentText = props.totalPaymentText,
    itemText = props.itemText,
    itemsText = props.itemsText,
    componentTrackingData = props.componentTrackingData;
  var prefixCls = (0, _getPrefixCls.getPrefixCls)('product');
  var _useLocale = (0, _LocaleProvider.useLocale)(),
    trans = _useLocale.trans;
  var _useComponentTracking = (0, _useTracking.useComponentTracking)({
      componentTrackingData: componentTrackingData,
      componentData: _objectSpread({}, props)
    }),
    tracker = _useComponentTracking.tracker,
    _useComponentTracking2 = _useComponentTracking.result,
    panelOrderTracking = _useComponentTracking2.panelOrder,
    panelOrderButtonTracking = _useComponentTracking2.panelOrderButton;
  var onClick = function onClick() {
    // 点击埋点
    (panelOrderButtonTracking === null || panelOrderButtonTracking === void 0 ? void 0 : panelOrderButtonTracking.trackingClick) && tracker.click(panelOrderButtonTracking.trackingClick);
    onButtonClick === null || onButtonClick === void 0 ? void 0 : onButtonClick({
      data: props
    });
  };
  var onOrderClick = function onOrderClick() {
    (panelOrderTracking === null || panelOrderTracking === void 0 ? void 0 : panelOrderTracking.trackingClick) && tracker.click(panelOrderTracking.trackingClick);
    handleOrderDetailRedirect === null || handleOrderDetailRedirect === void 0 ? void 0 : handleOrderDetailRedirect();
  };
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: "".concat(prefixCls, "__container"),
    key: orderSn,
    onClick: onOrderClick
  }, panelOrderTracking === null || panelOrderTracking === void 0 ? void 0 : panelOrderTracking.trackingImpressionProps), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "-shop")
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(prefixCls, "-shop__name")
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: shopImg,
    alt: "shop"
  }), /*#__PURE__*/_react.default.createElement("span", null, shopName)), /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(prefixCls, "-shop__type")
  }, orderStatusText)), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)("".concat(prefixCls, "-item"), 'chatbot-product-item')
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "chatbot_product_card_img",
    src: image,
    alt: "item"
  }), /*#__PURE__*/_react.default.createElement("p", {
    className: "".concat(prefixCls, "-item__title")
  }, title), /*#__PURE__*/_react.default.createElement("p", {
    className: "".concat(prefixCls, "-item__spec chatbot-product-item__spec")
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(prefixCls, "-item__desc")
  }, specification), /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(prefixCls, "-item__account")
  }, "x", amount)), /*#__PURE__*/_react.default.createElement("p", {
    className: "".concat(prefixCls, "-item__price chatbot-product-item__price")
  }, orderPrice)), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "-amount")
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(prefixCls, "-amount__count")
  }, itemCount, " ", itemCount > 1 ? itemsText || trans(_constants.ITEMS_TEXT) : itemText || trans(_constants.ITEM_TEXT)), /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(prefixCls, "-amount__price")
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "money-icon",
    src: _ic_guarantee.default,
    alt: "money"
  }), totalPaymentText || trans(_constants.TOTAL_PAYMENT_TEXT), ": ", /*#__PURE__*/_react.default.createElement("span", null, totalPrice))), showOrderId && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "-order-sn")
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(prefixCls, "-order-sn__title")
  }, orderIdText || trans(_constants.ORDER_ID_TRANSIFY_KEY)), /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(prefixCls, "-order-sn__content")
  }, orderSn)), /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: (0, _clsx.default)("".concat(prefixCls, "-buttons"), 'chatbot-product-buttons'),
    onClick: function onClick(element) {
      return element.stopPropagation();
    }
  }, panelOrderButtonTracking === null || panelOrderButtonTracking === void 0 ? void 0 : panelOrderButtonTracking.trackingImpressionProps), /*#__PURE__*/_react.default.createElement(_Button.Button, {
    className: "".concat(prefixCls, "-button"),
    type: "primary",
    onClick: onClick,
    action: action,
    text: selectOrderText || trans(_constants.SELECT_ORDER_TEXT),
    trackingData: componentTrackingData === null || componentTrackingData === void 0 ? void 0 : componentTrackingData.selectOrderButton,
    componentData: {
      content: selectOrderText || trans(_constants.SELECT_ORDER_TEXT)
    }
  })));
};
exports.ProductCard = ProductCard;